angular.module('signalview.chartTemplates', ['signalview.awsMetaData', 'signalview.azureMetaData']);
